<template>
  <ui-page :title="isLoggedIn ? $t('home.title') : ''">
    <section v-if="isLoggedIn">
      <p>{{ $t('home.subtitle') }}</p>
      <p>
        <router-link to="/apps" class="button is-link">{{
          $t('home.buttons.view_apps')
        }}</router-link>
      </p>
    </section>
  </ui-page>
</template>

<script>
import { mapGetters } from 'vuex';
import { configs } from 'config';

export default {
  data() {
    return {
      APP_NAME: configs().APP_NAME,
    };
  },
  computed: mapGetters('account', ['isLoggedIn']),
};
</script>

<style></style>
